import React, { useState } from "react";

export default function BlueprintDebug() {
  const [iid, setIid] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const fetchBlueprint = async () => {
    setError(null);
    setData(null);

    const resp = await fetch("https://api.invenire.app/blueprint/debug", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ interview_id: Number(iid) })
    });

    const json = await resp.json();
    if (!resp.ok) {
      setError(json);
      return;
    }

    setData(json);
  };

  return (
    <div style={{ padding: 20, background: "#0a1628", minHeight: "100vh", color: "white" }}>
      <h1>Blueprint Debugger</h1>
      <p>Enter an interview_id to preview all generated seed questions.</p>

      <input
        placeholder="interview_id"
        value={iid}
        onChange={(e) => setIid(e.target.value)}
        style={{ padding: 8, width: 200 }}
      />

      <button onClick={fetchBlueprint} style={{ marginLeft: 10 }}>
        Load Blueprint
      </button>

      {error && (
        <pre style={{ background: "#400", color: "white", padding: 10, marginTop: 20 }}>
          {JSON.stringify(error, null, 2)}
        </pre>
      )}

      {data && (
        <pre style={{ background: "#112", color: "white", padding: 10, marginTop: 20 }}>
          {JSON.stringify(data, null, 2)}
        </pre>
      )}
    </div>
  );
}